export enum MakeVaperScreenType {
    TIMED,
    OPTION,
    STEPS,
    AGREEMENT,
    EXIT
}

export enum MakeVaperWhiteBoxPosition {
    LEFT = "left",
    RIGHT = "right"
}

export enum MakeVaperTitleTextPosition {
    LEFT,
    CENTER
}

export enum MakeVaperSpudPosition {
    LEFT,
    RIGHT,
    CENTER
}

export enum MakeVaperSpudSize {
    LARGE = 0.9,
    MEDIUM = 0.8,
    SMALL = 0.5
}